var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { Chip } from '../internals/Chip';
import styles from './OptionChip.module.css';
export const OptionChip = (_a) => {
    var { className, children, disabled } = _a, rest = __rest(_a, ["className", "children", "disabled"]);
    return (React.createElement(Chip, Object.assign({ className: cx(className, styles.component, { [styles.disabled]: disabled }), inputClassName: styles.input, isSetClassName: styles.isSet, disabled: disabled }, rest), children));
};
//# sourceMappingURL=OptionChip.js.map